<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            {{header}}
        </div>
        <div class="content margin-top-30 margin-bottom-30">
            <div class="talent-result-info margin-bottom-10 text-left">
                Name : <span class="talent-result-info-extra">{{name}}</span> 
            </div>
            <div class="talent-result-info margin-bottom-10 text-left">
                Phone : <span class="talent-result-info-extra">{{phone}}</span> 
            </div>
            <div class="talent-result-info margin-bottom-10 text-left">
                Email : <span class="talent-result-info-extra">{{email}}</span> 
            </div>
        </div>
        <div class="content">
            <div class="talent-result-code">
               {{ summary }}
            </div>
        </div>

        <div v-for="order in neworders" :key="order.set">
            <div :style="order.hide==true?'display:none':''">
                <div class="content"  >
                    <div class="content">
                        <div v-if="order.info">
                            <div class="career-result-item-info text-left"> {{ order.info }}</div>
                        </div>
                    </div>
                </div>
                <div :class="order.offset=='false'?'margin-bottom-30':'margin-bottom-30'">  
                    <div :class="order.type=='radio'?'career-result-item-radio-title career-left':'career-result-item-title career-left'">
                        {{order.order}}
                    </div>
                    <div :class="order.type=='radio'?'career-result-item-radio-title career-right':'career-result-item-title career-right '">
                        {{order.title}}
                    </div>
                </div>

                <div v-if="order.type === 'list'">
                    <div v-for="description in order.description" :key="description.set">
                        <div class="career-right-answer">
                            <div class="career-result-item-description career-left-list text-left">
                                {{description.index}}
                            </div>
                            <div class="career-result-item-description career-right-list-answer list-area">
                                {{description.value}}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="order.type === 'option'">
                    <div v-for="description in order.description" :key="description.set">
                        <div class="career-right-option-answer career-result-item-description text-left">
                            <div class="career-option-text">
                                {{description.index}}
                                </div>

                                <div class="career-option-separator">
                                    |
                                </div>
                                <div class="career-option-text">
                                    {{description.value}}
                                </div>
                            </div>
                        </div>
                    </div>
                <div v-else>
                    <div class="career-right-answer career-result-item-description text-left text-area one-half">
                        {{order.description}}
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="content">
            <a class="generali-button-red margin-bottom-10  margin-top-30" @click="reset()">
                {{calculate_again_text}}
            </a>
            <div class="talent-result-note">
                *{{snapshot_text}}
            </div>
        </div>
    </div>
</template>
<style scoped>
.career-right-option-answer{
    float: left;
    margin-right: 50%;
    margin-left: 45px;
    border: 1px solid black;
    border-radius: 10px;
    padding: 10px 10px;
    min-width: 60%;
    margin-top: 10px;
    line-height: 12px !important;
}

.career-option-text {
    width: 49%;
    text-align: center;
    float: left;
}  

.career-option-separator {
    width: 2%;
    float: left;
    font-size: 21px;
}  

.text-area {
    padding: 0 10px;
    border-bottom: 1px solid #7A7B7A;
}

.list-area {
   
    padding-right: 10px;
    border-bottom: 1px solid #7A7B7A;
}

.career-result-info {
    margin-top: 60px;
}

.career-result-info-title{
    color: #7A7B7A;
    font-size: 16px;
    line-height: 19.2px;
    margin-bottom: 20px;
}

.career-result-item-info{
    font-size: 13px;
    font-family: "HelveticaNeueLTStd-Bd";
    color: #7A7B7A;
}

.career-result-title {
    background : #c1210c !important;
    color: #fff;
    font-size: 21px;
    line-height: 25.61px;
    padding: 15px;
}

.career-result-item-title{
    color: #7A7B7A;
    font-size: 15px;
    /* line-height: 19.2px; */
    line-height: normal;
    margin-bottom: 10px;
    text-align: left;
}

.career-result-item-text-title{
    font-size: 14px;
    color: #7A7B7A;
    line-height: 16.8px;
    /* text-align: left; */
    font-family: "HelveticaNeueLTStd-Bd";
    margin-bottom: 10px;
}

.career-result-item-radio-title{
    font-size: 14px;
    color: #7A7B7A;
    line-height: 16.8px;
    /* text-align: left; */
    font-family: "HelveticaNeueLTStd-Bd";
    margin-bottom: 10px;
}


.career-result-item-description{
    font-size: 13px;
    color: #7A7B7A;
    line-height: normal;
    /* line-height: 12px; */
    /* text-align: left; */
}

.career-left {
    width: 35px; 
    float: left;
    text-align: right;
}
.career-right{
    width: calc(100% - 35px); 
    float: right;
    text-align: left;
    padding-left: 10px;
    padding-right: 35px;
}

.career-right-answer{
    width: calc(100% - 75px); 
    /* float: right; */
    float: left;
    text-align: left;
    /* margin-left: 10px; */
    /* padding-right: 35px; */
    /* margin-left: 45px; */

   
    margin-left: 45px;

}



.career-left-list {
    width: 10px; 
    float: left;
    text-align: right;
    padding-top: 4px;
}

.career-right-list-answer{
    width: calc(100% - 20px); 
    /* float: right; */
    float: left;
    text-align: left;
    /* margin-left: 10px; */
    /* padding-right: 35px; */
    /* margin-left: 45px; */
    margin-left: 10px;
}

.talent-result-info {
    color: #7C7B7B;
    font-size: 16px;
}
.talent-result-info-extra {
    color: #7C7B7B !important;
}
.talent-result-code {
    background : #c1210c;
    height: 39px;
    color : #fff;
    font-size: 24px;
    padding: 8px 0;
}
.talent-result-category {
    width: 10%; 
    float: left;
}
.talent-result-description{
    width: 90%; 
    float: right;
}

.talent-category-title {
    font-size: 14px;
    color: #7C7B7B;
    line-height: normal;
    text-align: left;
}
.talent-category-description{
    font-size: 10px;
    color: #7C7B7B;
    line-height: normal;
    text-align: left;
}
.talent-show-button {
    font-size: 13px;
    color: #fff;
    text-decoration: underline;
}
.talent-result-note {
    font-size: 10px;
    color: #7A7B7A;
}
.talent-hide {
    display: none;
}

@media (min-width:768px){
    .text-area{
        width: 50% !important;
    }

    .list-area {
        width: 30% !important;
    }

    .career-right-option-answer{
        min-width: 40%;
    }
}
@media (max-width:540px){
    .career-right-option-answer{
        min-width: 80%;
    }
}
</style>
<script>
export default {
    name: "Result",
    data() {
        return {
            name: 'user',
            email: 'example@email.com',
            phone: '010xxxxxxx',
            orders: [{
                'language': 'en',
                "header": " Career & Lifestyle Survey Form",
                "summary": "Summary Result",
                'show_all':'Show All',
                'calculate_again':'Calculate again',
                'snapshot':'Screenshot this page for record purpose',
                'rate':[ " ",
                            " (Very Disstatisfy)",
                            " (Slighty Disstatisfy)", 
                            " (Neutral)", 
                            " (Slighty Disstatisfy)", 
                            " (Very Statisfy)"],
                'items': [{
                    'set': 'q1a',
                    'info': 'Based on a scale of 1-5, please rate your satisfaction level towards your current job. ( 1 is very dissatidfy, 5 is most satify)',
                    'order': "A.",
                    'title': 'Clear career future path',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1b',
                    'order': "B.",
                    'title': 'Enjoy current job',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1c',
                    'order': 'C.',
                    'title': 'Good compensation',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1d',
                    'order': 'D.',
                    'title': 'Career Advancement opportunity',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1e',
                    'order': 'E.',
                    'title': 'Personal recognition',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1f',
                    'order': 'F.',
                    'title': 'Career Satisfaction',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1g',
                    'order': 'G.',
                    'title': 'Personal Development ',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1h',
                    'order': 'H.',
                    'title': 'Independent & Flexibility',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1',
                    'order': '',
                    'title': 'As a whole, how do you rate your current job?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false'
                },{
                    'set': 'q2',
                    'order': '2.',
                    'title': 'What are the 3 most important factors if you were to start a new career / job? ',
                    'description': [
                        {
                            'index': 'i.',
                            'value': '-'
                        },{
                            'index': 'ii.',
                            'value': '-'
                        },{
                            'index': 'iii.',
                            'value': '-'
                        }
                    ],
                    'type': 'list',
                    'offset': 'true'
                },{
                    'set': 'q3',
                    'order': '3.',
                    'title': 'Can your current job help you to achieve these 3 factors?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q3a',
                    'order': '',
                    'title': 'If yes, how long will it takes?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false',
                    'hide': true
                },{
                    'set': '13',
                    'order': '4.',
                    'title': 'Given that you are free to make choices, what kind of lifestyle do you desire?',
                    'description': [
                        {
                            'set': 'q4a',
                            'index': 'House',
                            'value': '-'
                        },{
                            'set': 'q4b',
                            'index': 'Car',
                            'value': '-'
                        },{
                            'set': 'q4c',
                            'index': 'Holiday',
                            'value': '-'
                        },{
                            'set': 'q4d',
                            'index': 'Travel',
                            'value': '-'
                        },{
                            'set': 'q4e',
                            'index': 'Retire',
                            'value': '-'
                        },{
                            'set': 'q4f',
                            'index': "Children's Education",
                            'value': '-'
                        },{
                            'set': 'q4g',
                            'index': 'Family',
                            'value': '-'
                        },
                    ],
                    'type': 'option',
                    'offset': 'true'
                },{
                    'set': 'q5',
                    'order': '5.',
                    'title': 'Based on estimation, how much you would need to make to live your desired lifestyle?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q6',
                    'order': '6.',
                    'title': 'Can you live your desired lifestyle by continuing working for your current job only?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q6a',
                    'order': '',
                    'title': 'If yes, how long will it need to takes?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false',
                    'hide': true
                },{
                    'set': 'q7',
                    'order': '7.',
                    'title': 'If there is an opportunity which requires you to work hard for 3-5 years by following a proven system and likely will allow you to live your desired lifestyle, are you willing to invest 1-2 hours to explore?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                }
            ]
            },{
                'language': 'cn',
                "header": " 职业和生活方式调查表",
                "summary": "摘要结果",
                'show_all':'显示全部',
                'calculate_again':'重新演算',
                'snapshot':'"Screenshot" 储存档案记录',
                'rate':[ " "," (不满意)"," (有点不满意)", " (中立)", " (有点满意)", " (很满意)"],
                'items': [{
                    'set': 'q1a',
                    'info': '根据1-5的等级，请评价您对当前工作的满意程度。（1为非常不满意；5为最满意）',
                    'order': "A.",
                    'title': '清晰的未来职业展望',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1b',
                    'order': "B.",
                    'title': '享受现在的工作',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1c',
                    'order': 'C.',
                    'title': '良好的薪酬待遇',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1d',
                    'order': 'D.',
                    'title': '晋升机会',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1e',
                    'order': 'E.',
                    'title': '个人认可',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1f',
                    'order': 'F.',
                    'title': '满意',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1g',
                    'order': 'G.',
                    'title': '个人发展',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1h',
                    'order': 'H.',
                    'title': '独立及具伸缩性',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1',
                    'order': '',
                    'title': '总的来说，你目前工作的评分如何?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false'
                },{
                    'set': 'q2',
                    'order': '2.',
                    'title': '如果您想开始新的职业/工作，现在对您来说最重要的三个因 素是什么?',
                    'description': [
                        {
                            'index': 'i.',
                            'value': '-'
                        },{
                            'index': 'ii.',
                            'value': '-'
                        },{
                            'index': 'iii.',
                            'value': '-'
                        }
                    ],
                    'type': 'list',
                    'offset': 'true'
                },{
                    'set': 'q3',
                    'order': '3.',
                    'title': '你目前的工作能帮助你实现这三个因素吗?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q3a',
                    'order': '',
                    'title': '如果是，需要多长时间?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false'
                },{
                    'set': '13',
                    'order': '4.',
                    'title': '如果让你自由选择，你想要什么样的生活方式？',
                    'description': [
                        {
                            'set': 'q4a',
                            'index': '租',
                            'value': '-'
                        },{
                            'set': 'q4b',
                            'index': '汽车',
                            'value': '-'
                        },{
                            'set': 'q4c',
                            'index': '旅游',
                            'value': '-'
                        },{
                            'set': 'q4d',
                            'index': '旅行',
                            'value': '-'
                        },{
                            'set': 'q4e',
                            'index': '退休',
                            'value': '-'
                        },{
                            'set': 'q4f',
                            'index': '孩子教育',
                            'value': '-'
                        },{
                            'set': 'q4g',
                            'index': '家庭',
                            'value': '-'
                        },
                    ],
                    'type': 'option',
                    'offset': 'true'
                },{
                    'set': 'q5',
                    'order': '5.',
                    'title': '根据您的估计，要过上想要的生活方式，您一年需要赚多少钱？',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q6',
                    'order': '6.',
                    'title': ' 如果你继续现在的工作，你能实现你想要的生活方式吗？',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q6a',
                    'order': '',
                    'title': '如果能，需要多长时间？',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false'
                },{
                    'set': 'q7',
                    'order': '7.',
                    'title': '如果有一个机会，需要你努力工作 3-5 年，经过验证的系统，可能 会让您过上您想要的生活方式，您愿意投资1-2 小时探索吗？',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                }
            ]
            },{
                'language': 'bm',
                "header": "Kaji Selidik Kerjaya & Gaya Hidup",
                "summary": "Hasil Rumusan",
                'show_all':'Show All',
                'calculate_again':'Kira lagi',
                'snapshot':'"Screenshot" halaman ini untuk tujuan rekod',
                'rate':[ " "," (Sangat Tidak Puas Hati)"," (Sedikit tidak berpuas hati)", " (Berkecuali)", " (Sedikit berpuas hati)", " (Sangat Memuaskan)"],
                'items': [{
                    'set': 'q1a',
                    'info': 'Berdasarkan skala 1-5, sila nilaikan tahap kepuasan anda terhadap pekerjaan semasa anda. (1 sangat tidak puas hati, 5 paling memuaskan)',
                    'order': "A.",
                    'title': 'Masa depan kerjaya yang jelas',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1b',
                    'order': "B.",
                    'title': 'Nikmati pekerjaan semasa',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1c',
                    'order': 'C.',
                    'title': 'Ganjaran yang baik',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1d',
                    'order': 'D.',
                    'title': 'Peluang kemajuan kerjaya',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1e',
                    'order': 'E.',
                    'title': 'Pengiktirafan peribadi',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1f',
                    'order': 'F.',
                    'title': 'Kepuasan hati',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1g',
                    'order': 'G.',
                    'title': 'Pembangunan Diri',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1h',
                    'order': 'H.',
                    'title': 'Berdikari & Fleksibel',
                    'description': '-',
                    'type': 'rate',
                    'offset': 'true'
                },{
                    'set': 'q1',
                    'order': '',
                    'title': 'Secara keseluruhan, bagaimanakah anda menilai perkerjaan semasa anda?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false'
                },{
                    'set': 'q2',
                    'order': '2.',
                    'title': ' Jika anda ingin memulakan kerjaya/pekerjaan baru, yang manakah 3 faktor yang paling penting untuk anda sekarang?',
                    'description': [
                        {
                            'index': 'i.',
                            'value': '-'
                        },{
                            'index': 'ii.',
                            'value': '-'
                        },{
                            'index': 'iii.',
                            'value': '-'
                        }
                    ],
                    'type': 'list',
                    'offset': 'true'
                },{
                    'set': 'q3',
                    'order': '3.',
                    'title': 'Bolehkah pekerjaan anda sekarang membantu anda mencapai 3 faktor ini?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q3a',
                    'order': '',
                    'title': 'Jika ya, berapa lama masa yang diperlukan?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false'
                },{
                    'set': '13',
                    'order': '4.',
                    'title': 'Jika anda diberi kebebasan untuk memilih, apakah gaya hidup yang anda inginkan?',
                    'description': [
                        {
                            'set': 'q4a',
                            'index': 'Rumah',
                            'value': '-'
                        },{
                            'set': 'q4b',
                            'index': 'Kereta',
                            'value': '-'
                        },{
                            'set': 'q4c',
                            'index': 'Cuti',
                            'value': '-'
                        },{
                            'set': 'q4d',
                            'index': 'Melancong',
                            'value': '-'
                        },{
                            'set': 'q4e',
                            'index': 'Bersara',
                            'value': '-'
                        },{
                            'set': 'q4f',
                            'index': 'Pendidikan Anak',
                            'value': '-'
                        },{
                            'set': 'q4g',
                            'index': 'Keluarga',
                            'value': '-'
                        },
                    ],
                    'type': 'option',
                    'offset': 'true'
                },{
                    'set': 'q5',
                    'order': '5.',
                    'title': 'Berdasarkan anggaran anda, untuk menikmati gaya hidup yang diidamkan, berapa pendapatan yang anda perlukan setiap tahun?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q6',
                    'order': '6.',
                    'title': 'Jika anda meneruskan pekerjaan anda sekarang, dapatkah anda mencapai gaya hidup keinginan anda?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                },{
                    'set': 'q6a',
                    'order': '',
                    'title': 'Jika ya, berapa lama masa yang diperlukan?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'false'
                },{
                    'set': 'q7',
                    'order': '7.',
                    'title': 'Jika ada peluang yang memerlukan anda bekerja keras selama 3-5 tahun dengan mengikuti sistem yang terbukti dan berkemungkinan akan membolehkan anda	mencapai gaya hidup impian anda, adakah anda sanggup meluangkan masa 1-2 jam untuk meneroka?',
                    'description': '-',
                    'type': 'text',
                    'offset': 'true'
                }
            ]
            }],
            language: '',
            conclusion: {},
            result: '',
            hide: true,
            hideButton: false,
            chosenIndex: 0
        }
    },
    mounted(){
        if(localStorage.getItem('career_test')){
           
            try{
                this.conclusion = JSON.parse(localStorage.getItem('career_test'))
                this.name = this.conclusion.name
                this.phone = this.conclusion.phone
                this.email = this.conclusion.email
                this.language = this.conclusion.language

                for(var a = 0; a<this.orders.length;a++){
                    if(this.language === this.orders[a].language){
                        this.chosenIndex = a
                    }
                }

                var career_test = JSON.parse(localStorage.getItem('career_test'));
                var rate = this.orders[this.chosenIndex].rate;

                this.orders[this.chosenIndex].items.forEach(function (index) {
                  
                    switch (index.type) {
                        case 'rate':
                                index.description = career_test[index.set] + ' ' + rate[career_test[index.set]] ;
                            break;
                        case 'option':
                                index['description'].forEach(function (element) {
                                    element.value = career_test[element.set];
                                });
                            break;
                        case 'list':
                                index['description'].forEach(function (list, index) {
                                    list['value'] = career_test['q2'][index];       
                                });
                            break;
                        case 'text':
                                index.description = career_test[index.set];

                                if(index.set == 'q3a' && career_test['q3'] == 'Yes'){
                                    index.hide = false;
                                }

                                if(index.set == 'q6a' && career_test['q6'] == 'Yes'){
                                    index.hide = false;
                                }
                            break
                        default:
                                index.description = career_test[index.set];
                            break;
                    }
                });

                console.log(this.orders[this.chosenIndex])
            }
            catch(e){
                // localStorage.removeItem('career_test')
            }
        }
    },
    methods: {
        reset(){
            localStorage.removeItem('career_test')
            this.$router.push({path: 'career-lifestyle-survey'})
        },
        showall(){
            this.hide = false
            this.hideButton = true
        }
    }, 
    computed:{
        neworders() {
            return this.orders[this.chosenIndex].items 
        },
        show_all_text() {
            return this.orders[this.chosenIndex].items.show_all
        },
      
        snapshot_text() {
            return this.orders[this.chosenIndex].snapshot
        },
        calculate_again_text() {
            return this.orders[this.chosenIndex].calculate_again
        },

        header() {
            return this.orders[this.chosenIndex].header
        },

        summary() {
            return this.orders[this.chosenIndex].summary
        },
    },
}
</script>